import { Controller } from '@hotwired/stimulus'

// Visually clamps indexable copy behind a Read More toggle.
// Full text remains in the DOM for crawlability.
export default class extends Controller {
  static targets = ['content', 'button']
  static classes = ['collapsed']
  static values = {
    moreLabel: { type: String, default: 'Read More' },
    lessLabel: { type: String, default: 'Read Less' }
  }

  connect () {
    this.collapse()
  }

  toggle () {
    if (this.expanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand () {
    this.expanded = true
    this.contentTarget.classList.remove(...this.collapsedClasses)
    this.buttonTarget.setAttribute('aria-expanded', 'true')
    this.buttonTarget.textContent = this.lessLabelValue
  }

  collapse () {
    this.expanded = false
    this.contentTarget.classList.add(...this.collapsedClasses)
    this.buttonTarget.setAttribute('aria-expanded', 'false')
    this.buttonTarget.textContent = this.moreLabelValue
  }
}
